import { combineReducers, createStore, applyMiddleware } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import authReducer from "./auth";
import gameReducer from "./game";
const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  auth: authReducer,
  game: gameReducer,
});
const persistedReducer = persistReducer(persistConfig, rootReducer);
// const store = createStore(persistedReducer, applyMiddleware(thunk));
// const persistor = persistStore(store);
// export default { store, persistor };
// const unsubscribe = store.subscribe(() => {
//   //   console.log(store.getState());
// });
const store = createStore(persistedReducer, applyMiddleware(thunk));
const persistor = persistStore(store);
export default () => {
  // let store = createStore(persistedReducer, applyMiddleware(thunk));
  // let persistor = persistStore(store);
  return { store, persistor };
};
// const unsubscribe = store.subscribe(() => {
//   console.log(store.getState().bets);
// });
